import { createTheme } from '@mui/material/styles';

const theme = createTheme({
  palette: {
    primary: {
      main: '#0075BF',
    },
    secondary: {
      main: '#062C43',
    },
    success: {
      main: '#7AC142',
    },
  },
  components: {
    MuiDialog: {
      defaultProps: {
        disableEscapeKeyDown: true,
      },
    },
    MuiModal: {
      defaultProps: {
        disableEscapeKeyDown: true,
      },
    },
  },
});

export default theme;
